<template>
  <div class="mt-8 pb-8 flex justify-center">
    <div v-if="outfitter.trip_advisor" class="w-24">
      <a :href="checkLink(outfitter.trip_advisor)" target="_blank">
        <img class="social-icon mx-auto" src="@/assets/icons/tripadvisor.svg" />
      </a>
    </div>
    <div v-if="outfitter.facebook" class="w-24">
      <a :href="checkLink(outfitter.facebook)" target="_blank">
        <img class="social-icon mx-auto" src="@/assets/icons/facebook.svg" />
      </a>
    </div>
    <div v-if="outfitter.twitter" class="w-24">
      <a :href="checkLink(outfitter.twitter)" target="_blank">
        <img class="social-icon mx-auto" src="@/assets/icons/twitter.svg" />
      </a>
    </div>
    <div v-if="outfitter.instagram" class="w-24">
      <a :href="checkLink(outfitter.instagram)" target="_blank">
        <img class="social-icon mx-auto" src="@/assets/icons/instagram.svg" />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "FooterOutfitter",
  data() {
    return {};
  },
  methods: {
    checkLink(link) {
      return "https://" + link.replace("https://", "").replace("http://", "");
    },
    columnCount() {
      return "colspan-4";
    },
  },
  computed: {
    outfitter() {
      return this.$store.getters["search/getOutfitter"];
    },
  },
};
</script>

<style scoped>
.social-icon {
  max-width: 30px;
}
</style>
